import { boot } from "quasar/wrappers";
import ErrorComponent from "components/ErrorComponent.vue";

export default boot(({ app }) => {
  // Make ErrorComponent globally available
  app.component("error-component", ErrorComponent);
});
